import { useMemo, useState } from 'react';
import { useAppContext } from '../../../Services/AppContext';
import { useLazyUserMetaQuery, User } from '../../../graphql/graphql';
import { useEffectAsync } from '../../../helpers';

export default function useDefaultSettings() {
	const { userData } = useAppContext();
	const [isLoading, setIsLoading] = useState(false);
	const [user, setUser] = useState<User | undefined | null>(undefined);
	const [getUserMeta] = useLazyUserMetaQuery();

	const handleLoadUserMeta = async () => {
		setIsLoading(true);
		const data = await getUserMeta({ id: userData.id });
		setUser(data?.data?.user);
		setIsLoading(false);
	};

	useEffectAsync(async () => {
		await handleLoadUserMeta();
	}, []);

	const metaMap = useMemo(() => {
		const map: Record<string, string | undefined> = {};
		user?.meta?.forEach(item => {
			if (item?.key) {
				map[item.key] = item.value ?? undefined;
			}
		});
		return map;
	}, [user]);

	return {
		sendMedicalReportDuringCaseClosing:
			metaMap['sendMedicalReportDuringCaseClosing'],
		deliveryOfPrescriptionIdentifier:
			metaMap['deliveryOfPrescriptionIdentifier'],
		defaultPrescriptionValidityInDays:
			metaMap['defaultPrescriptionValidityInDays'],
		isDefaultSettingsLoading: isLoading,
		reloadDefaultSettings: handleLoadUserMeta,
	};
}
